// key使用拼音全称
export default {
  'jigouleixing': '机构类型',
  'jigoumingcheng': '机构名称',
  'jigoudaima': '机构代码',
  'zhiwu': '职务：',
  'zhanghuzhangtang': '账户账套',
  'zhanghuleixing': '账户类型',
  'zhanghumingcheng': '账号名称',
  'xingzhengquyu': '行政区域',
  'zhangtao': '账套',
  'wuyequyumingcheng': '物业区域名称',
  'wuyefuwuqiye': '物业服务企业',
  'kaifajianshedanwei': '开发建设单位',
  'toupiaoshixiang': '投票事项',
  'toupiaoleixing': '投票类型',
  'toupiaoqudao': '投票渠道',
  'toupiaojieguo': '投票结果',
  'gongshiqichuOne': '公示起初日期', //公示起初日期有两个时间段，One结尾代表第一个时间段
  'gongshiqichuTwo': '公示起初日期',
  'gongshijiesuanriqiOne': '公示结算日期', //公示结算日期有两个时间段，One结尾代表第一个时间段
  'gongshijiesuanriqiTwo': '公示结算日期',
  'chuangjianren': '创建人',
  'kaishishijian': '开始时间',
  'jieshushijian': '结束时间',
  'chengxinleixing': '诚信类型',
  'wuyeqiyemingcheng': '物业企业名称',
  'dengjiriqi1': '登记日期', //登记日期有两个时间段，1结尾代表第一个时间段
  'dengjiriqi2': '登记日期',
  'qiyemingcheng': '企业名称',
  'qiyedaima': '企业代码',
  'xiangmumingcheng': '项目名称',
  'guanjianci': '关键词',
  'wuyequyu': '物业区域',
  'wuyequyudizhi': '物业区域地址',
  'loudongdizhi': '楼栋地址',
  'yewuleixing': '业务类型',
  'yewudanhao': '业务单号',
  'yewuzhuangtai': '业务状态',
  'shoulishijian': '受理时间',
  'miaosu': '描述',
  'zhi': '至'
};